window.SessionStorageActions =
{
    setItem: function (key, value) {
        sessionStorage.setItem(key, value);
    },

    getItem: function (key) {
        return sessionStorage.getItem(key);
    },

    removeItem: function (key) {
        sessionStorage.removeItem(key);
    },

    clearData: function () {
        sessionStorage.clear();
    }
}